import { render, staticRenderFns } from "./clientDetails.vue?vue&type=template&id=2171ac4b&scoped=true&"
import script from "./clientDetails.vue?vue&type=script&lang=js&"
export * from "./clientDetails.vue?vue&type=script&lang=js&"
import style0 from "./clientDetails.vue?vue&type=style&index=0&id=2171ac4b&prod&scoped=true&lang=scss&"
import style1 from "./clientDetails.vue?vue&type=style&index=1&id=2171ac4b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2171ac4b",
  null
  
)

export default component.exports